import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-inclusions-exclusions',
  templateUrl: './inclusions-exclusions.component.html',
  styleUrls: ['./inclusions-exclusions.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class InclusionsExclusionsComponent implements OnInit {
  errorWarningData: any = {};
  @Input() MatterConveyancingDetailsForm: FormGroup;
  propertyTypeLookupsData: any[];
  sub: Subscription;

  @Input() toolTipList: any;
  toolTipPostion = 'above';
  @Input() testBool;
  constructor() {}

  ngOnInit(): void {}
}
